import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../DMSHeader/DMSHeader";
import { useTranslation } from "react-i18next";
import DistrictWiseBranches from "./DistrictWiseBranches";

// Component for rendering district wise branch details component
const DistrictWiseBranchesMain = () => {
  // Initialize translation hook for internationalization
  const { t } = useTranslation();

  // Initialize GridStack layout on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Define layout configuration for grid items
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with title and action buttons
      component: (
        <DMSHeader
          title={t("district_wise")}
          fileName="DistrictWiseBranches"
          showmenu={true}
          showdownload={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 15,
      id: 2,
      // Main content component displaying district-wise branches data
      component: <DistrictWiseBranches />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      {/* Render grid layout with defined layout data */}
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default DistrictWiseBranchesMain;
